/* eslint-disable no-nested-ternary */
export default {
  branchOptions: state => {
    // const { scopeLimit, branchCode } = rootState.auth.userData
    if (state.branches !== null) {
      const branch = state.branches.filter(item => item.status === 'Active').map(item => ({ label: item.name, value: item.code })).sort((a, b) => (a.label === b.label ? 0 : a.label < b.label ? -1 : 1))
      // if (scopeLimit && scopeLimit.toLowerCase() === 'global') {
      //   return branch
      // }
      // return branch.filter(item => item.value === branchCode)
      return branch
    }
    return []
  },
  bankOptions: state => {
    if (state.banks !== null) {
      return state.banks.map(item => ({ label: item.name, value: item.code })).sort((a, b) => (a.label === b.label ? 0 : a.label < b.label ? -1 : 1))
    }
    return []
  },
  getTillAccount: state => state.tillAccount,
  getVaultAccount: state => state.vaultAccount,
  getCurrentFinancialDate: state => state.financialDate,
  getCorporateDetails: state => state.corporateDetails,
}
